module.exports = __webpack_public_path__ + "static/img/file.13d7f3c1.svg";